export default "__VITE_ASSET__B_WGS0Pc__"